function MissingJobDataMessage() {
  return <div data-testid="missing-data">Missing data in single job config</div>
}

export default MissingJobDataMessage
